export class Pagination<T> {
  pageSize?: number;
  pageNumber?: number;
  totalPages?: number;
  totalRecords?: number;
  records?: number;
  nextPage?: string | null;
  previousPage?: string | null;
  firstPage?: string;
  lastPage?: string;
  data?: T[];

  constructor(data: Partial<Pagination<T>> = {}) {
    Object.assign(this, data);
  }

  deserialize(input: any): this {
    this.data = input.data ?? [];

    this.pageNumber   = input.pageNumber   ?? 1;
    this.pageSize     = input.pageSize     ?? 10;
    this.totalRecords = input.totalRecords ?? 0;

    return this;
  }
}